import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import "./utils/vee-validate";
import VueSweetalert2 from 'vue-sweetalert2';
import VueIziToast from 'vue-izitoast';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import './assets/css/style.css';
import './assets/css/main.css';
import './assets/css/components.css';
import './assets/css/custom.css';
import 'izitoast/dist/css/iziToast.min.css';
import "vue-select/dist/vue-select.css";
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueIziToast);
Vue.use(VueSweetalert2);
Vue.use(VueAxios,axios)
Vue.use( CKEditor );
Vue.config.ignoredElements = [/^ion-/]
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
